export const initialState = {
  isLoading: false,
  isLoadMore: false,
  error: null,
  detail: {},
  classList: [],
  totalClass: 0,
}
